// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"713":"ac2c06fd","914":"1d465d33"}[chunkId] + ".chunk.js";
};